export default {
  data () {
    return {
      activeProduct: 1,
      traitList: [{
        a: {
          title: '一机一号',
          text: '一个手机登录一个微信，尽量保障安全性'
        },
        b: {
          title: '品牌手机',
          text: '甄选小米、华为等大品牌机器，全国联保'
        },
        c: {
          title: '官方微信',
          text: '支持最新版本官方微信客户端，安全稳定'
        },
        d: {
          title: 'APP管控',
          text: '只显示管理员允许的APP，禁止随意下载'
        }
      },
      {
        a: {
          title: '多号一聊',
          text: '多账号集中对话，可同时接待回复多个账号好友的消息。'
        },
        b: {
          title: '一号多聊',
          text: '同一账号好友，不同客服跟进聊天，防止跟进不及时。'
        },
        c: {
          title: '好友标签',
          text: '好友标签化管理，分组统计更有利于管理再营销。'
        },
        d: {
          title: '一键群发',
          text: '一键推送朋友圈内容，好友一键群发，高效提升客户转化率。'
        }
      }, {
        a: {
          title: '数据中台',
          text: '客户数据统一管理，客户标签化管理。           '
        },
        b: {
          title: '聊天留存',
          text: '客服聊天内容、电话录音、手机短信实时同步。'
        },
        c: {
          title: '敏感检测',
          text: '自动拦截包含敏感关键词的消息，系统自动预警。'
        },
        d: {
          title: '数据分析',
          text: '精准统计渠道加粉数量，员工当然沟通数量，便于绩效分析。'
        }
      }]
    }
  }
}
